import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getProducts } from "../lib/api";
import { ProductCard } from "./ProductCard";
import Navbar from "./Navbar";
import CartDrawer from "./CartDrawer";
import Footer from "./Footer";

export default function Merch() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  const categories = useMemo(
    () => ["All", ...Array.from(new Set(products.map((p) => p.category)))],
    [products]
  );
  const shown = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div className="grain min-h-screen">
      <Navbar />
      <CartDrawer />
      <main className="pt-28 pb-24 max-w-7xl mx-auto px-5 sm:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white mb-8"
          data-testid="merch-back-link"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>

        <p className="overline text-blaze mb-4">The full store</p>
        <h1 className="font-heading font-900 tracking-tight text-4xl sm:text-6xl leading-[0.95]">
          The Merch Vault
        </h1>
        <p className="mt-6 text-white/70 max-w-2xl leading-relaxed">
          Apparel, headwear, tools, and drinkware — each piece a reminder to lead with purpose,
          build with discipline, and unlock with intention.
        </p>

        <div className="mt-10 flex flex-wrap gap-2" data-testid="merch-filters">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                filter === c ? "bg-blaze text-white" : "border border-white/20 text-white/60 hover:bg-white/10"
              }`}
              data-testid={`merch-filter-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {shown.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
